<template>
    <page class="dashboard-profile-index">
        <template #title>{{$t('pages.dashboard.profile.index.title')}}</template>

        <template #content>
            <m-accordion-profile/>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import MAccordionProfile from "@modules/accordions/concrete/m-accordion-profile";

    export default {
        name: "dashboard-profile-index",
        components: {MAccordionProfile, Page},
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.profile.index.meta.title')
            }
        }
    }
</script>

<style lang="scss">
    .dashboard-profile-index {
        .v-expansion-panel {
            &__container {
                box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61);
                border-radius: 3px;
                padding: 0 1rem !important;
                margin-bottom: 1rem;
            }
        }
    }
</style>
